module.exports = __webpack_public_path__ + "static/media/attendence.e98166b3.svg";